import React, { useEffect, useState } from 'react';
import { Table, Spinner, Form } from 'react-bootstrap';
import '../styles/TallesAdminTable.css';

const API_URL = process.env.REACT_APP_API_URL || "/";

// ...existing code...
const TallesAdminTable = ({ talles }) => {
  const [filtro, setFiltro] = useState('');
  // Solo mostrar empleados con al menos un talle cargado
  const filtrados = talles.filter(t => {
    const tieneTalle = t.camisa_invierno || t.pantalon_invierno || t.campera || t.camisa_verano || t.borcego;
    return tieneTalle && String(t.legajo).includes(filtro.trim());
  });
  return (
    <div className="talles-table-container">
      <Form.Control
        type="text"
        placeholder="Buscar por legajo"
        value={filtro}
        onChange={e => setFiltro(e.target.value)}
        className="talles-table-filter"
      />
      {!talles || talles.length === 0 ? (
        <Spinner animation="border" />
      ) : (
        <Table striped bordered hover responsive className="talles-table">
          <thead className="talles-table-head">
            <tr>
              <th>Nombre</th>
              <th>Legajo</th>
              <th>Camisa Invierno</th>
              <th>Pantalón Invierno</th>
              <th>Pantalón Verano</th>
              <th>Campera</th>
              <th>Remera/Camisa Verano</th>
              <th>Borcego</th>
            </tr>
          </thead>
          <tbody>
            {filtrados.map((t, i) => {
              return (
                <tr key={i}>
                  <td>{t.nombre}</td>
                  <td>{t.legajo}</td>
                  <td>{t.camisa_invierno || '-'}</td>
                  <td>{t.pantalon_invierno || '-'}</td>
                  <td>{t.pantalon_verano || '-'}</td>
                  <td>{t.campera || '-'}</td>
                  <td>{t.remera || t.camisa_verano || '-'}</td>
                  <td>{t.borcego || '-'}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default TallesAdminTable;
